import * as toastMessages from '../../../core/toastMessages';
import { sendReclamationEmail } from '../../reclamations/actions';

export const extractClaimId = (
  notification: any,
  bodyContent: any,
  rawMessage: string
): string | null => {
  const direct =
    notification?.claimId ||
    notification?.reclamationId ||
    notification?.reclamation?.id ||
    notification?.data?.claimId ||
    notification?.data?.reclamationId ||
    notification?.meta?.claimId ||
    notification?.meta?.reclamationId;
  if (direct) return direct;

  const linkValue = notification?.link || bodyContent.linkUrl;
  const linkText = typeof linkValue === 'string' ? linkValue : '';
  const claimMatch = linkText.match(/claims\/(\d+)/i) || linkText.match(/reclamations\/(\d+)/i);
  if (claimMatch) return claimMatch[1];

  const textClaimMatch = rawMessage.match(/claim\s*#\s*(\d+)/i);
  return textClaimMatch ? textClaimMatch[1] : null;
};

export const getNotificationSiteId = (notification: any, fallbackSiteId: number): number => {
  return (
    notification?.siteId ||
    notification?.data?.siteId ||
    notification?.meta?.siteId ||
    fallbackSiteId
  );
};

interface ApproveClaimEmailParams {
  claimId: string | null;
  notificationSiteId: number;
  operatorGroup: any;
  dispatch: (action: any) => void;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const approveAndSendClaimEmail = ({
  claimId,
  notificationSiteId,
  operatorGroup,
  dispatch,
  onSuccess,
  onError,
}: ApproveClaimEmailParams): void => {
  const resolvedClaimId = Number(claimId);
  const resolvedSiteId = Number(notificationSiteId);
  const operatorGroupDetails = operatorGroup?.details || {};
  const operatorGroupPayload = operatorGroup
    ? {
        name: operatorGroup.name,
        details: {
          email: operatorGroupDetails.email || operatorGroup.email,
          emailSendingDomain:
            operatorGroupDetails.emailSendingDomain || operatorGroup.emailSendingDomain,
        },
      }
    : null;

  if (!resolvedClaimId || !resolvedSiteId || !operatorGroupPayload) {
    toastMessages.generateToastr(
      'error',
      'Unable to send email',
      'Missing claim or operator group details.'
    );
    return;
  }

  dispatch(
    sendReclamationEmail({
      siteId: resolvedSiteId,
      email: {
        id: resolvedClaimId,
        templateKey: 'EmailCustomerClaimMessage',
        operatorGroup: operatorGroupPayload,
      },
      callback: () => {
        toastMessages.generateToastr(
          'success',
          'Email sent',
          'Customer claim email was approved and sent.'
        );
        if (onSuccess) onSuccess();
      },
      errorCallback: (error: any) => {
        if (!error?.statusCode && !error?.responseStatus) {
          toastMessages.apiError(error);
        }
        if (onError) onError(error);
      },
    })
  );
};
